import React from "react";
import PropTypes from "prop-types";
import {
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
} from "@material-ui/core";
import { Checkbox } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
});

const AppTableHead = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCountIsCheck,
    onRequestSort,
    headCells,
    checkboxIndeterminate,
    checkboxChecked,
    isOnSelectedAll
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {(numSelected || numSelected === 0) && (
          <TableCell padding="checkbox">
            <Checkbox
              indeterminate={checkboxIndeterminate !== undefined ? checkboxIndeterminate : numSelected > 0 && numSelected < rowCountIsCheck}
              checked={checkboxChecked !== undefined ? checkboxChecked : rowCountIsCheck > 0 && numSelected === rowCountIsCheck}
              onChange={onSelectAllClick}
              inputProps={{ "aria-label": "select all desserts" }}
              color="primary"
              disabled={isOnSelectedAll}
            />
          </TableCell>
        )}
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={
              headCell.numeric === "left" ||
              headCell.numeric === "right" ||
              headCell.numeric === "center"
                ? headCell.numeric
                : "left"
            }
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
            className={'font-weight-bolder text-capitalize'}
          >
            {headCell.sort ? (
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
              >
                {t(headCell.label)}
                {orderBy === headCell.id ? (
                  <span className={classes.visuallyHidden}>
                    {order === "desc"
                      ? "sorted descending"
                      : "sorted ascending"}
                  </span>
                ) : null}
              </TableSortLabel>
            ) : (
              t(headCell.label)
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

AppTableHead.propTypes = {
  numSelected: PropTypes.number,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCountIsCheck: PropTypes.number.isRequired,
  headCells: PropTypes.array.isRequired,
  checkboxIndeterminate: PropTypes.bool,
  checkboxChecked: PropTypes.bool,
  isOnSelectedAll: PropTypes.bool
};

export default AppTableHead;